import { connect } from 'react-redux';
import { compose, hoistStatics } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Page404 from './Page404';

const enhance = compose(
  connect(null, null),
  translate('portal'),
);

export default withRouter(hoistStatics(enhance)(Page404));



// WEBPACK FOOTER //
// ./src/views/page404/index.js